export default "__VITE_ASSET__BgDymtZe__"